module.exports = __webpack_public_path__ + "static/bg-054841c137a3bff0a6d9e7efa8d62f05.png";